import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5303 6.53027L8.53027 10.5303C8.23738 10.8232 7.76262 10.8232 7.46973 10.5303L3.46973 6.53027L4.53027 5.46973L8 8.93945L11.4697 5.46973L12.5303 6.53027Z",
		fill: "currentColor"
	})
});
export default SvgChevronDownSmall;
